import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-guest-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuGuestComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
